import ajax from "@/lib/ajax";

/**
 * 读取读取历次宣教
 * @param patientId 患者Id
 */
export async function GetPreviousKnowledgeList(patientId: string) {
    let res = await ajax.get(`/api/services/app/PDEducation/GetPreviousKnowledgeList?patientId=` + patientId);
    return res.data.result;
}

/**
 * 新增宣教完成情况
 * @param payload 
 */
export async function InsertPreviousEducation(payload: any) {
    let res = await ajax.post(`/api/services/app/PDEducation/InsertExecuteEducation`, payload);
    return res.data.result;
}


// WEBPACK FOOTER //
// ./src/api/pdOutPatient/pdEducation/pdPreviousEducation/index.ts